module.exports = __webpack_public_path__ + "img/gb.345d29b7.svg";